import { LineNumberCombinedProps } from './types';

const usePresenter = (props: LineNumberCombinedProps): LineNumberCombinedProps => {
  return props;
};

export default usePresenter;
